import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { useTopBar } from '@/contexts/TopBarContext'
import { websiteOverviewApi } from '@/api/website'
import { Card } from '@/components/ui/card'

/** Every organisation with Sites switched on or a website, for CertSlate staff. */
export default function SitesPage() {
  useTopBar(<span className="text-sm font-medium text-gray-900">Websites</span>)
  const { data, isLoading } = useQuery({ queryKey: ['superadmin-sites'], queryFn: websiteOverviewApi.list })

  return (
    <div className="max-w-5xl space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Websites</h1>
        <p className="text-sm text-gray-500 mt-1">Organisations with CertSlate Sites switched on. To switch it on for another organisation, open it from Tenants.</p>
      </div>
      <Card>
        {isLoading && <p className="p-5 text-sm text-gray-400">Loading…</p>}
        {data && data.length === 0 && <p className="p-5 text-sm text-gray-400">No organisation has Sites switched on yet.</p>}
        <ul className="divide-y divide-gray-100">
          {data?.map(r => (
            <li key={r.tenantId}>
              <Link to={`/superadmin/sites/${r.tenantId}`} className="flex items-center gap-4 px-5 py-3 hover:bg-gray-50">
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-gray-900 truncate">{r.tenantName}</span>
                  <span className="block text-xs text-gray-500 truncate">{r.primaryHostname ?? 'No website yet'}</span>
                </span>
                {r.newEnquiries > 0 && <span className="text-xs font-medium bg-amber-100 text-amber-800 rounded-full px-2 py-0.5">{r.newEnquiries} new</span>}
                {r.hasSite && <span className="text-xs text-gray-500">{r.customerEditingEnabled ? 'Customer edits' : 'Staff only'}</span>}
                <span className="text-xs font-medium text-gray-700 w-24 text-right">{r.hasSite ? r.status : r.sitesEnabled ? 'Not created' : 'Off'}</span>
              </Link>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  )
}
